<template>
  <div class="gs-assets-list">
    <div class="gs-assets-list__toolbar">
      <div class="gs-assets-list__toolbar-left">
        <slot name="header-left"> </slot>
      </div>
      <div class="gs-assets-list__toolbar-right">
        <div class="gs-assets-list__toolbar-extra">
          <slot name="header-right"> </slot>
        </div>
        <div class="gs-assets-list__view-toggle">
          <button
            type="button"
            class="gs-assets-list__view-button"
            aria-label="Grid view"
            title="Grid view"
            :aria-pressed="viewType == 'grid'"
            @click="viewType = 'grid'"
            :class="{
              'is-active': viewType == 'grid',
            }"
          >
            <grid-icon class="w-5 h-5 fill-current"/>
          </button>
          <button
            type="button"
            class="gs-assets-list__view-button"
            aria-label="List view"
            title="List view"
            :aria-pressed="viewType == 'list'"
            @click="viewType = 'list'"
            :class="{
              'is-active': viewType == 'list',
            }"
          >
            <list-icon class="w-5 h-5 fill-current"/>
          </button>
        </div>
      </div>
    </div>
    <div class="gs-assets-list__content">
      <slot v-if="viewType == 'grid'" name="gridContent"></slot>
      <slot v-else name="listContent"></slot>
    </div>
  </div>
</template>

<script>
import ListIcon from '@/assets/images/icons/ListIcon.svg';
import GridIcon from '@/assets/images/icons/GridIcon.svg';

export default {
  components: {
    ListIcon,
    GridIcon,
  },
  name: 'AssetsList',
  data() {
    return {
      viewType: 'grid',
    };
  },
};
</script>

<style lang="scss">
.gs-assets-list {
  width: 100%;
}

.gs-assets-list__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.gs-assets-list__toolbar-left,
.gs-assets-list__toolbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.gs-assets-list__toolbar-right {
  margin-left: auto;
}

.gs-assets-list__view-toggle {
  display: inline-flex;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #dfe4ee;
  border-radius: 6px;
}

.gs-assets-list__view-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 40px;
  color: #ff5b7f;
  background: #ffffff;
  border: 0;
  cursor: pointer;
  transition: color .15s ease, background .15s ease;
}

.gs-assets-list__view-button + .gs-assets-list__view-button {
  border-left: 1px solid #edf0f6;
}

.gs-assets-list__view-button.is-active {
  color: #ffffff;
  background: #ff5b7f;
}

.gs-assets-list__view-button:focus-visible {
  position: relative;
  z-index: 1;
  outline: 3px solid rgba(255, 91, 127, .28);
  outline-offset: -3px;
}

.gs-assets-list__content {
  width: 100%;
}

@media (max-width: 700px) {
  .gs-assets-list__toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .gs-assets-list__toolbar-right {
    margin-left: 0;
  }
}
</style>
